export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14065.cb0499ed.jpg";